/**
 * 注文入力画面
*/
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import constMap from '../../const/const';
import authService from "../../services/common/authService";
import dialogService from "../../services/common/dialogService";
import jyuService from "../../services/jyu/jyuService";
import { getMsg, isEmpty, fractionNumber, isNotEmpty, isNumber } from "../../util/util";
import CustomGrid from "../common/CustomGrid";
import IsdSelectBox from "../common/isdselectbox";
import isdFooter from "../common/isdFooter";
import IsdTextboxYmd from "../common/IsdTextboxYmd";
import "../../css/jyu/Jyuf104.css";
import asyncService from "../../services/common/asyncService";
import IsdTextBox from "../common/isdTextBox";
import myGrid from "../../store/myGridStore";
import { observer } from "mobx-react";
import sessionStore from "../../store/sessionStore";
import IsdEditable from "../common/isdEditable";
import stateStore from "../../store/stateStore";
import rootScope from "../../store/rootScopeStore";
import errMsgService from "../../services/common/errMsgService";
import $ from 'jquery';
import { checkDayOff, checkDayOffConfirm, goto } from "../../util/isd-utils";
import { formatDateToText } from "../../util/util";


/**
 * sample
 * 
 * @param {any} props 
 * @returns 
 */

// デフォルトの結果単位情報
let jchutnicdDefault = '';
const Jyuf104 = observer((props) => {

    const [gridData, setGridData] = useState([]);
    const [selectdata, setSelectdata] = useState([]);
    const [slipNumber, setSlipNumber] = useState('');
    const [updDate, setUpdDate] = useState('');
    const initialRef = {
        seizoymd: useRef(null),
        uketrihhocd: useRef(null),
        tsushinrancd: useRef(null),
        tsushinrannaiyo: useRef(null),
        grdShincd: useRef(null),
        grdJchutnicd: useRef(null)
    }
    const dispatch = useDispatch();

    // モードを取得
    function getMode() {
        return window.location.href.split('/').pop();
    }

    /**
     * 商品コード、単位コードより単価を算出する
     * @param {*} shincd 
     * @param {*} tnicd 
     * @returns 単価
     */
    const calcTnk = (shincd, tnicd, tiknkbn, tknftknkbn) => {
        // 商品コードから商品情報を取得する
        const infoItem = stateStore.state.infoItem[shincd];
        const unitCodes = infoItem.unitCodes;
        // 引数が指定されていない場合、stateStoreから取得
        if (!tiknkbn) {
            const tiknkbn = infoItem.tiknkbn;
        }
        let tnk = infoItem.keyakutnk;
        // 選択単位の、定貫不定貫区分を取得
        // 引数が指定されていない場合、stateStoreから取得
        if (!tknftknkbn) {
            const tknftknkbn = Object.values(unitCodes).find((item) => item.code == tnicd).tknftknkbn;
        }
        // 単価を算出する
        let resultTnk = tnk;
        switch (tiknkbn) {
            // 定貫区分="定貫"の場合、単価 = 契約単価
            case rootScope.kbn["TIKNKBN"].TIKN.code:
                resultTnk = tnk;
                break;
            // 定貫区分="不定貫"の場合
            case rootScope.kbn["TIKNKBN"].FTIKN.code:
                // 定貫不定貫区分 = "定貫"の場合、単価 = 契約単価
                if (tknftknkbn == rootScope.kbn["TKNFTKNKBN"].TIKN.code) {
                    resultTnk = tnk;
                }
                // 定貫不定貫区分 = "不定貫"の場合、単価 = 契約単価 × 重量換算値
                else if (tknftknkbn == rootScope.kbn["TKNFTKNKBN"].FTIKN.code) {
                    resultTnk = tnk * infoItem.jryoksanchi;
                }
                break;
        }
        return resultTnk;
    }

    /**
     * 重量数量算出処理
     * @param {*} shincd 
     * @param {*} sryo 
     * @param {*} tnicd 
     * @returns 総数
     */
    const calcSosu = (shincd, sryo, tnicd) => {
        // 商品コードから商品情報を取得する
        const infoItem = stateStore.state.infoItem[shincd];
        if (!infoItem) return { first: "", last: "" };
        const tniList = infoItem.unitCodes;
        let sryoNew = sryo;
        let tni = "";
        if (tnicd != infoItem.ftiknzikotnicd) {
            tni = tniList.find(x => x.code == infoItem.syotnicd) ? tniList.find(x => x.code == infoItem.syotnicd).name : "";
        } else {
            tni = tniList.find(x => x.code == infoItem.ftiknzikotnicd) ? tniList.find(x => x.code == infoItem.ftiknzikotnicd).name : "";
        }
        // 大単位
        if (tnicd == infoItem.daitnicd) {
            sryoNew = sryoNew * infoItem.daitniknsnkisu;
        }
        // 中単位
        if (tnicd == infoItem.chutnicd) {
            sryoNew = sryoNew * infoItem.chutniknsnkisu;
        }

        return { first: sryoNew, last: tni };
    }

    /**
     * // 商品情報から単位セレクトボックスデータを取得
     * @param {*} unitCodes 商品コード
     * @returns 
     */
    const getTniSelectboxdata = (unitCodes) => {
        const result = unitCodes.map((unitCode, index) => {
            return {
                code: unitCode.tnicd
                , name: unitCode.tnimei
                , tknftknkbn: unitCode.tknftknkbn
            }
        })
        return result;
    }

    // 合計金額の計算
    // useEffect(() => {
    //     if (!!myGrid.props.data) {
    //         let total = 0;
    //         myGrid.props?.data.map((item, index) => {
    //             if (item.jchugaku > 0) {
    //                 total += item.jchugaku;
    //             }
    //         })
    //         stateStore.state.jchugokeigaku = total;
    //     }
    // }, [myGrid.props.data])

    useEffect(() => {
        // 納品希望日が営業休日になっているか確認する
        if (!!stateStore.state?.uketrihhocd.length && !!stateStore.state?.seizoymd) {
            checkSeizoymd();
        }
    }, [stateStore.state.uketrihhocd == '10'])

    const checkSeizoymd = () => {
        const obj = { name: '納品希望日' }
        errMsgService.delMsgLabel(obj);
        // 納品希望日が有効な日付かチェック
        if (isDateFormatInvalid(stateStore.state?.seizoymd)) {
            errMsgService.addMsgLabel("EJYU0330", obj);
            // 営業日カレンダーチェック
        } else if (stateStore.state?.uketrihhocd != '10') {
            checkDayOff(dispatch, '納品希望日', 'seizoymd', stateStore.state?.seizoymd);
        }
    }

    // グリッドデータ再計算
    const recalcGridData = () => {
        let newGridData = [];
        for (let i = 0; i < gridData.length; i++) {
            newGridData.push(gridData[i]);
            // 契約単価を更新
            // newGridData[i].keyakutnk = calcTnk(newGridData[i].shincd, newGridData[i].jchutnicd);
            // 金額を更新
            // let jchugaku = newGridData[i].jchusryo * newGridData[i].keyakutnk;
            // newGridData[i].jchugaku = fractionNumber(jchugaku, stateStore.state.infoItem[newGridData[i].shincd].gakuhasukbn, 0);
            newGridData[i].jchusosu = calcSosu(newGridData[i].shincd, newGridData[i].jchusryo, newGridData[i].jchutnicd);
        }
        setGridData(newGridData);
        myGrid.props.data = newGridData;
    }

    const onBlurSeizoymd = () => {
        // 納品希望日チェック
        checkSeizoymd();

        // 契約改訂年月日対応
        let dnpyoNo = slipNumber;
        let mode = getMode();
        let dateTo = formatDateToText(new Date(), 'yyyy-MM-dd');
        let date = new Date();
        date.setFullYear(date.getFullYear() - 1);
        let dateFrom = formatDateToText(date, 'yyyy-MM-dd');
        let seizoymd = stateStore.state.seizoymd.replaceAll('/', '-');

        dispatch(asyncService.async(jyuService.jyua102(dateFrom, dateTo, dnpyoNo, mode, seizoymd), (respose) => {
            let newGridData;
            if (respose.data) {
                if (!isEmpty(respose.data.message)) {
                    dialogService.okDialog(null, respose.data.message, null, okFunc, null, null, null);
                } else {
                    switch (mode) {
                        case '1':
                        case '2':
                        case '3':
                            // if (respose.data.infoItemCodes) {
                            //     Object.values(respose.data.infoItemCodes).map((item, index) => {
                            //         // 契約単価を更新する
                            //         stateStore.state.infoItem[item.shincd].keyakutnk = item.keyakutnk;
                            //     });
                            // }
                            // グリッドデータの契約単価、金額を再計算する
                            recalcGridData();
                    }
                }
            }
        }));
    }

    // 不正な日付フォーマットか判定する
    const isDateFormatInvalid = (strDate) => {
        // YYYY/MM/DDの形式か判定
        if (!strDate.match(/\d{4}\/\d{2}\/\d{2}/)) {
            return true;
        }
        // 有効な日付かチェック
        let date = new Date(strDate);
        return isNaN(date.getDate());
    }

    // 得意先注文表示値情報取得IFを呼び出して初期表示情報を取得する。
    useEffect(() => {
        // 初期処理
        init();
    }, [getMode()]);

    const init = () => {
        errMsgService.clearAllMsg();
        let mode = getMode();
        let dateTo = formatDateToText(new Date(), 'yyyy-MM-dd');
        let date = new Date();
        let dnpyoNo;
        initialRef.seizoymd.current.focus();
        if (mode === '1') {
            dnpyoNo = '';
        }
        else {
            const params = rootScope.openerParams;
            dnpyoNo = params.dnpyoNo;
            setSlipNumber(dnpyoNo);
        }
        date.setFullYear(date.getFullYear() - 1);

        stateStore.state = {
            jchuymd: '',
            seizoymd: '',
            uketrihhocd: '',
            tsushinrancd: '',
            tsushinrannaiyo: '',
            jchutnicd: '',
            shincd: '',
            // 契約単価(受注単価)
            // keyakutnk: '',
            // 受注金額
            // jchugaku: '',
            jchusosu: '',
            // 合計金額
            // jchugokeigaku: '',
            selectboxdataGrid: [],
            selectboxshincd: [],
            selectboxtni: [],
            // infoItemCodesを格納するオブジェクト
            infoItem: {},
            disabled: {
                jchuymd: false,
                seizoymd: false,
                uketrihhocd: false,
                tsushinrancd: false,
                tsushinrannaiyo: false,
                jchutnicd: false,
                fixBtnDisabledFlag: false,
                registerBtnDisabledFlg: false,
                delBtnDisabledFlag: false,
            }
        }

        let currentDate = formatDateToText(new Date(), constMap.format.yyyymmdd);
        let nextDate = formatDateToText(new Date().setDate(new Date().getDate() + 1), constMap.format.yyyymmdd);
        stateStore.state.jchuymd = currentDate;
        stateStore.state.seizoymd = nextDate;

        rootScope.footer = {
            clearBtn: getMode() !== '4' && {
                clearBtnDisabledFlag: false,
                view: constMap.btnView.clear, // クリア
                func: clearOnclick.bind(this)
            },
            otherBtn: [
                {
                    disabled: 'disabled.registerBtnDisabledFlg',
                    view: constMap.btnView.ins,
                    func: registerData.bind(this)
                },
                {
                    disabled: 'disabled.fixBtnDisabledFlag',
                    view: constMap.btnView.upd,
                    func: editData.bind(this)
                },
                {
                    disabled: 'disabled.delBtnDisabledFlag',
                    view: constMap.btnView.del,
                    func: deleteCustomerOrder.bind(this)
                }
            ],
            endBtn: {
                view: getMode() !== '1' && constMap.btnView.back,
                func: back.bind(this)
            }
        }

        myGrid.props = {
            columnDefs: [
                {
                    Header: '商品',
                    accessor: 'shincd',
                    Cell: IsdEditable,
                    editor: {
                        changeEditorFunc: (row, cell, name, original) => {
                            return {
                                componentAf: original.isSelectbox ? 'selectbox' : ''
                                , valueAf: original.isSelectbox ? original[name]
                                    : getName(original[name])
                            };
                        },
                        changeFunc: (event, row, cell, name, original, updateMyEdits) => {
                            // 変更後の商品情報を取得
                            const changeObj = stateStore.state.infoItem[event.target.value];
                            // 加工区の更新
                            updateMyEdits(row, "kkokbn", changeObj ? changeObj.kkokbn : 0);
                            // 単位の更新
                            updateMyEdits(row, "unitCodes", changeObj.unitCodes);
                            updateMyEdits(row, "jchutnicd", changeObj.unitCodes["0"].code);
                            // 単価の更新
                            // updateMyEdits(row, "keyakutnk", changeObj ? calcTnk(event.target.value, changeObj.unitCodes["0"].code) : 0);
                            // 数量、金額のクリア
                            updateMyEdits(row, "jchusryo", '');
                            // updateMyEdits(row, "jchugaku", 0);
                            updateMyEdits(row, "jchusosu", calcSosu(event.target.value, 0, changeObj.unitCodes["0"].code));
                        },
                        data: 'selectboxshincd',
                        valueField: 'value',
                        labelField: 'name',
                        disabled: getMode() === '4'
                    },
                    sticky: 'left',
                    toggle: true,
                    width: 360
                },
                {
                    Header: '数量',
                    accessor: 'jchusryo',
                    sticky: 'left',
                    width: 115,
                    Cell: IsdEditable,
                    editor: {
                        blurFunc: (event, row, cell, name, original, updateMyEdits) => {
                            const gridData = myGrid.props.data[row];
                            const infoItem = stateStore.state.infoItem[gridData.shincd];
                            // 金額の算出、更新
                            // let jchugaku = event.target.value * gridData.keyakutnk;
                            // jchugaku = fractionNumber(jchugaku, infoItem.gakuhasukbn, 0);
                            // updateMyEdits(row, "jchugaku", jchugaku);
                            if ((isNotEmpty(event.target.value) && !isNumber(event.target.value)) || isEmpty(event.target.value)) {
                                updateMyEdits(row, "jchusryo", "");
                                updateMyEdits(row, "jchusosu", calcSosu(gridData.shincd, null, gridData.jchutnicd));
                                return;
                            }
                            updateMyEdits(row, "jchusosu", calcSosu(gridData.shincd, event.target.value, gridData.jchutnicd));
                        },
                        component: 'numberbox',
                        ctrlproptype: "num.dot.comma",
                        maxintlength: "7",
                        maxdeclength: "3",
                        disabled: getMode() === '4'
                    }
                },
                {
                    Header: '単位',
                    accessor: 'jchutnicd',
                    width: 90,
                    Cell: IsdEditable,
                    editor: {
                        component: 'selectbox',
                        data: 'unitCodes',
                        changeFunc: (event, row, cell, name, original, updateMyEdits) => {
                            const gridData = myGrid.props.data[row];
                            // 単位の更新
                            updateMyEdits(row, "jchutnicd", event.target.value);
                            // 単価の更新
                            // updateMyEdits(row, "keyakutnk", calcTnk(shincd, event.target.value));

                            // 数量、金額の更新
                            // updateMyEdits(row, "jchusryo", '');
                            updateMyEdits(row, "jchusryo", gridData.jchusryo);
                            // updateMyEdits(row, "jchugaku", 0);
                            updateMyEdits(row, "jchusosu", calcSosu(gridData.shincd, gridData.jchusryo, event.target.value));
                        },
                        disabled: getMode() === '4',
                    }
                },
                // {
                //     Header: '単価',
                //     accessor: 'keyakutnk',
                //     width: 90,
                //     Cell: IsdEditable,
                //     editor: {
                //         component: 'numberbox',
                //         value: stateStore.state?.keyakutnk,
                //         ctrlproptype: "num.dot.comma",
                //         maxintlength: "5",
                //         maxdeclength: "2",
                //         disabled: true,
                //     }
                // },
                // {
                //     Header: '金額',
                //     accessor: 'jchugaku',
                //     width: 115,
                //     Cell: IsdEditable,
                //     editor: {
                //         component: 'numberbox',
                //         value: stateStore.state?.jchugaku,
                //         ctrlproptype: "num.comma",
                //         isdmaxlength: "9",
                //         disabled: true
                //     }
                // }
                {
                    Header: '総数',
                    accessor: 'jchusosu',
                    width: 200,
                    Cell: IsdEditable,
                    editor: {
                        component: 'doubletextbox',
                        value: stateStore.state?.jchusosu,
                        ctrlproptypefirst: "num.dot.comma",
                        maxintlengthfirst: "7",
                        maxdeclengthfirst: "3",
                        classNamefirst: "w180",
                        classNamelast: "w80",
                        disabled: true
                    }
                }
            ],
            data: []
        }
        let dateFrom = formatDateToText(date, 'yyyy-MM-dd');

        // 区分値情報を取得する。
        let selectboxdatas;

        // 備考ﾏｽﾀ情報を取得する。
        dispatch(asyncService.async(jyuService.jyua106('JYUF104'), (respose) => {
            if (respose.data) {
                selectboxdatas = [];
                Object.values(respose.data).map(item => {
                    selectboxdatas.push({
                        value: item.bikocd,
                        name: item.bikoniyo,
                        key: 0
                    })
                });
                setSelectdata(selectboxdatas);
            }
        }));

        // 得意先注文画面の初期表示情報を取得する。
        let seizoymd = stateStore.state?.seizoymd ? stateStore.state.seizoymd.replaceAll('/', '-') : dateTo;
        setGridData([]);
        dispatch(asyncService.async(jyuService.jyua102(dateFrom, dateTo, dnpyoNo, mode, seizoymd), (respose) => {
            let newGridData;
            if (respose.data) {
                if (!isEmpty(respose.data.message)) {
                    dialogService.okDialog(null, respose.data.message, null, okFunc, null, null, null);
                } else {
                    let seizoymdValue;
                    let uketrihhocdValue;
                    let tsushinrannaiyoValue;
                    // let jchugokeigaku;
                    let tniSelectboxdata;
                    switch (mode) {
                        case '1':
                            selectboxdatas = [];
                            newGridData = [];
                            tniSelectboxdata = {};
                            if (respose.data.infoItemCodes) {
                                Object.values(respose.data.infoItemCodes).map((item, index) => {
                                    selectboxdatas.push({
                                        value: item.shincd,
                                        name: item.shinryksyomei,
                                        key: 0
                                    })
                                    // 商品ごとの単位情報を取得
                                    if (!!item.unitCodes) {
                                        tniSelectboxdata[item.shincd] = getTniSelectboxdata(item.unitCodes);
                                    }
                                    // 商品情報の格納
                                    stateStore.state.infoItem[item.shincd] = {
                                        shinryksyomei: item.shinryksyomei
                                        , keyakutnk: item.keyakutnk
                                        , gakuhasukbn: item.gakuhasukbn
                                        , kkokbn: item.kkokbn ? item.kkokbn : "0"
                                        , tiknkbn: item.tiknkbn ? item.tiknkbn : "0"
                                        , ftiknzikoknrikbn: item.ftiknzikoknrikbn ? item.ftiknzikoknrikbn : "0"
                                        , jryoksanchi: item.jryoksanchi
                                        , unitCodes: tniSelectboxdata[item.shincd]
                                        , daitnicd: item.daitnicd
                                        , chutnicd: item.chutnicd
                                        , syotnicd: item.syotnicd
                                        , ftiknzikotnicd: item.ftiknzikotnicd
                                        , daitniknsnkisu: item.daitniknsnkisu
                                        , chutniknsnkisu: item.chutniknsnkisu
                                    }
                                    // const tiknkbn = item.tiknkbn ? item.tiknkbn : "0";
                                    // const tknftknkbn = tniSelectboxdata[item.shincd]["0"].tknftknkbn;
                                    newGridData.push({
                                        shincd: item.shincd
                                        , jchusryo: ''
                                        , kkoniyo: ''
                                        , isSelectbox: !(index < 10 && item.ordertimes)
                                        // , jchugaku: 0
                                        , kkokbn: item.kkokbn ? item.kkokbn : "0"
                                        , gakuhasukbn: item.gakuhasukbn
                                        , unitCodes: tniSelectboxdata[item.shincd]
                                        , jchutnicd: tniSelectboxdata[item.shincd]["0"].code
                                        // グリッドデータの契約単価は、単位コードの初期値を参照して設定する
                                        // , keyakutnk: calcTnk(item.shincd, tniSelectboxdata[item.shincd]["0"].code, tiknkbn, tknftknkbn)
                                        , jchusosu: calcSosu(item.shincd, 0, tniSelectboxdata[item.shincd]["0"].code)
                                    });
                                });
                            }

                            stateStore.state.selectboxshincd = selectboxdatas;
                            setGridData(newGridData);
                            if (stateStore.state?.seizoymd) {
                                stateStore.state.registerBtnDisabledFlg = false;
                            } else {
                                stateStore.state.registerBtnDisabledFlg = true;
                            }
                            stateStore.state.fixBtnDisabledFlag = true;
                            stateStore.state.delBtnDisabledFlag = true;
                            isdFooter.isDisabled();
                            return
                        case '2':
                        case '3':
                            seizoymdValue = respose.data.customerOderInfo[0].seizoymd.substring(0, 10).replaceAll('-', '/');
                            uketrihhocdValue = respose.data.customerOderInfo[0].uketrihhocd;
                            tsushinrannaiyoValue = respose.data.customerOderInfo[0].bikomei;
                            // jchugokeigaku = respose.data.customerOderInfo[0].jchugokeigaku;
                            stateStore.state.jchuymd = currentDate;
                            stateStore.state.seizoymd = seizoymdValue;
                            stateStore.state.uketrihhocd = uketrihhocdValue;
                            stateStore.state.tsushinrancd = tsushinrannaiyoValue;
                            stateStore.state.tsushinrannaiyo = tsushinrannaiyoValue;
                            // stateStore.state.jchugokeigaku = jchugokeigaku;
                            selectboxdatas = [];
                            tniSelectboxdata = {};
                            if (respose.data.infoItemCodes) {
                                Object.values(respose.data.infoItemCodes).map((item) => {
                                    selectboxdatas.push({
                                        value: item.shincd,
                                        name: item.shinryksyomei,
                                        key: 0
                                    })
                                    // 商品ごとの単位情報を取得
                                    if (!!item.unitCodes) {
                                        tniSelectboxdata[item.shincd] = getTniSelectboxdata(item.unitCodes);
                                    }
                                    // 商品情報を取得
                                    stateStore.state.infoItem[item.shincd] = {
                                        shinryksyomei: item.shinryksyomei
                                        , keyakutnk: item.keyakutnk
                                        , gakuhasukbn: item.gakuhasukbn
                                        , kkokbn: item.kkokbn ? item.kkokbn : "0"
                                        , tiknkbn: item.tiknkbn ? item.tiknkbn : "0"
                                        , ftiknzikoknrikbn: item.ftiknzikoknrikbn ? item.ftiknzikoknrikbn : "0"
                                        , jryoksanchi: item.jryoksanchi
                                        , unitCodes: tniSelectboxdata[item.shincd]
                                        , daitnicd: item.daitnicd
                                        , chutnicd: item.chutnicd
                                        , syotnicd: item.syotnicd
                                        , ftiknzikotnicd: item.ftiknzikotnicd
                                        , daitniknsnkisu: item.daitniknsnkisu
                                        , chutniknsnkisu: item.chutniknsnkisu
                                    }
                                });
                            }
                            if (respose.data.customerOderInfo) {
                                newGridData = [];
                                Object.values(respose.data.customerOderInfo).map((data, index) => {
                                    const item = respose.data.infoItemCodes.find(x => x.shincd === data.shincd);
                                    const tiknkbn = item.tiknkbn ? item.tiknkbn : "0";
                                    const tknftknkbn = rootScope.tniList.find(x => x.tnicd == data.jchutnicd).tknftknkbn;
                                    newGridData.push({
                                        shincd: item.shincd
                                        , jchusryo: data.jchusryo
                                        , kkoniyo: ''
                                        , isSelectbox: !(index < 10 && item.ordertimes)
                                        // , jchugaku: data.jchugaku
                                        , kkokbn: data.kkokbn ? data.kkokbn : "0"
                                        , gakuhasukbn: item.gakuhasukbn
                                        , unitCodes: tniSelectboxdata[item.shincd]
                                        , jchutnicd: data.jchutnicd
                                        // グリッドデータの契約単価は、単位コードを参照して設定する
                                        // , keyakutnk: calcTnk(item.shincd, data.jchutnicd, tiknkbn, tknftknkbn)
                                        , jchusosu: calcSosu(item.shincd, data.jchusryo, data.jchutnicd)
                                    });
                                });
                                setGridData(newGridData);
                            }
                            stateStore.state.selectboxshincd = selectboxdatas;
                            stateStore.state.registerBtnDisabledFlg = true;
                            stateStore.state.fixBtnDisabledFlag = false;
                            stateStore.state.delBtnDisabledFlag = false;
                            isdFooter.isDisabled();
                            return
                        case '4':
                            let jchuymd = respose.data.customerOderInfo[0].jchuymd.substring(0, 10).replaceAll('-', '/');
                            seizoymdValue = respose.data.customerOderInfo[0].seizoymd.substring(0, 10).replaceAll('-', '/');
                            let uketrihhocd = respose.data.customerOderInfo[0].uketrihhocd;
                            let tsushinrannaiyo = respose.data.customerOderInfo[0].bikomei;
                            stateStore.state.jchuymd = jchuymd;
                            stateStore.state.seizoymd = seizoymdValue;
                            stateStore.state.uketrihhocd = uketrihhocd;
                            stateStore.state.tsushinrancd = tsushinrannaiyo;
                            stateStore.state.tsushinrannaiyo = tsushinrannaiyo;
                            stateStore.state.disabled.seizoymd = true;
                            stateStore.state.disabled.uketrihhocd = true;
                            stateStore.state.disabled.jchutnicd = true;
                            stateStore.state.disabled.tsushinrancd = true;
                            stateStore.state.disabled.tsushinrannaiyo = true;
                            rootScope.footer.otherBtn = [];
                            selectboxdatas = [];
                            tniSelectboxdata = {};
                            newGridData = [];
                            if (respose.data.infoItemCodes) {
                                Object.values(respose.data.infoItemCodes).map((item) => {
                                    selectboxdatas.push({
                                        value: item.shincd,
                                        name: item.shinryksyomei,
                                        key: 0
                                    })
                                    // 商品ごとの単位情報を取得
                                    if (!!item.unitCodes) {
                                        tniSelectboxdata[item.shincd] = getTniSelectboxdata(item.unitCodes);
                                    }
                                    // 商品コードをkeyとして、商品情報を取得
                                    let key = item.shincd;
                                    stateStore.state.infoItem[key] = {
                                        shinryksyomei: item.shinryksyomei
                                        , keyakutnk: item.keyakutnk
                                        , gakuhasukbn: item.gakuhasukbn
                                        , kkokbn: item.kkokbn ? item.kkokbn : "0"
                                        , tiknkbn: item.tiknkbn ? item.tiknkbn : "0"
                                        , ftiknzikoknrikbn: item.ftiknzikoknrikbn ? item.ftiknzikoknrikbn : "0"
                                        , jryoksanchi: item.jryoksanchi
                                        , unitCodes: tniSelectboxdata[item.shincd]
                                        , daitnicd: item.daitnicd
                                        , chutnicd: item.chutnicd
                                        , syotnicd: item.syotnicd
                                        , ftiknzikotnicd: item.ftiknzikotnicd
                                        , daitniknsnkisu: item.daitniknsnkisu
                                        , chutniknsnkisu: item.chutniknsnkisu
                                    }
                                });
                            }
                            if (respose.data.customerOderInfo) {
                                newGridData = [];
                                Object.values(respose.data.customerOderInfo).map((data, index) => {
                                    const item = respose.data.infoItemCodes.find(x => x.shincd === data.shincd);
                                    const tiknkbn = item.tiknkbn ? item.tiknkbn : "0";
                                    const tknftknkbn = rootScope.tniList.find(x => x.tnicd == data.jchutnicd).tknftknkbn;
                                    newGridData.push({
                                        shincd: item.shincd
                                        , jchusryo: data.jchusryo
                                        , kkoniyo: ''
                                        , isSelectbox: !(index < 10 && item.ordertimes)
                                        // , jchugaku: data.jchugaku
                                        , kkokbn: data.kkokbn ? data.kkokbn : "0"
                                        , gakuhasukbn: item.gakuhasukbn
                                        , unitCodes: tniSelectboxdata[item.shincd]
                                        , jchutnicd: data.jchutnicd
                                        // グリッドデータの契約単価は、単位コードを参照して設定する
                                        //  , keyakutnk: calcTnk(item.shincd, data.jchutnicd, tiknkbn, tknftknkbn)
                                        , jchusosu: calcSosu(item.shincd, data.jchusryo, data.jchutnicd)
                                    });
                                });
                                setGridData(newGridData);
                            }
                            stateStore.state.selectboxshincd = selectboxdatas;
                            return
                    }
                }
            }
        })).catch(err => {
            dialogService.okDialog(null, err.message, null, okFunc, null, null, null);
        });
    }

    //入力変更時に実行されるイベント
    const handleInputChange = event => {
        const { name, value } = event.target;
        if (value) {
            errMsgService.delMsgKey(name);
            if (value < stateStore.state?.jchuymd) {
                errMsgService.addMsgKey('EJYU0040', name);
            } else {
                let selectDate = new Date(stateStore.state?.jchuymd);
                selectDate.setDate(selectDate.getDate() + 60);
                let newDate = formatDateToText(selectDate, constMap.format.yyyymmdd)
                if (value > newDate) {
                    errMsgService.addMsgKey('EJYU0190', name);
                } else {
                    errMsgService.delMsgKey(name);
                }
            }
        }
    };

    // 変更を選択
    const selectChange = event => {
        if (event.target.value) {
            stateStore.state.disabled.registerBtnDisabledFlg = false;
        } else {
            stateStore.state.disabled.registerBtnDisabledFlg = true;
        }
        isdFooter.isDisabled();
    }

    // ハンドル選択変更
    const handleSelectChange = event => {
        const { value } = event.target;
        stateStore.state.disabled.tsushinrannaiyo = value ? true : false;
        stateStore.state.tsushinrannaiyo = value;
    };

    // 得意先注文更新IFを呼び出して得意先注文情報を登録する。
    const registerData = () => {
        let dataInsertsDetail = [];
        // 商品情報の詳細
        myGrid.props.data.map((item, index) => {
            if (isNotEmpty(item.jchusryo) && isNumber(item.jchusryo) && item.jchusryo > 0) {
                let dataDetail;
                dataDetail = {
                    shincd: item.shincd.replaceAll(' ', '')
                    , jchusryo: Number(item.jchusryo)
                    , jchutnk: 0
                    , jchutnicd: item.jchutnicd
                    , kkokbn: item.kkokbn
                    , jchugaku: 0
                };
                dataInsertsDetail.push(dataDetail);
            }
        })
        let params = {
            dnpyono: slipNumber,
            jchuymd: stateStore.state?.jchuymd.replaceAll('/', '-'),
            seizoymd: stateStore.state?.seizoymd.replaceAll('/', '-'),
            uketrihhocd: stateStore.state?.uketrihhocd,
            bikocd: isEmpty(stateStore.state?.tsushinrancd) ? null : $("option[value='" + stateStore.state?.tsushinrancd + "']")[0].innerText,
            //bikocd: $("option[value='" + stateStore.state?.tsushinrancd + "']")[0].innerText,
            bikomei: isEmpty(stateStore.state?.tsushinrannaiyo) ? null : stateStore.state?.tsushinrannaiyo,
            //bikomei: stateStore.state?.tsushinrannaiyo,
            updDate: updDate,
            // jchugokeigaku: myGrid.props.data.reduce((result, item) => result + item.jchugaku, 0)
        };
        // 有効な日付かチェック
        if (isDateFormatInvalid(stateStore.state?.seizoymd)) {
            dialogService.okDialog('EJYU0330', getMsg('EJYU0330'));
            return;
        }
        if (dataInsertsDetail.length === 0) {
            dialogService.okDialog('EJYU0050', getMsg('EJYU0050'));
        } else {
            function commit(params) {
                let checkFlag = false;
                if (!checkFlag) {
                    params.tksakicmonmsaiAtDto = dataInsertsDetail;
                    params.mode = getMode();
                    // 公開DBに得意先注文情報を保存する。
                    dispatch(asyncService.async(jyuService.jyua103(params), (respose) => {
                        if (respose.data) {
                            dialogService.okDialog('IJYU0200', null, [respose.data], okFunc, null, null, null);
                        }
                    }));
                }
            }
            // 受取方法 = '送り'の場合、納品希望日に休日を指定可能
            if (params.uketrihhocd == '10') {
                commit(params);
            } else {
                checkDayOffConfirm(dispatch, '納品希望日', 'seizoymd', stateStore.state?.seizoymd, commit, params);
            }
        }
    }

    // 得意先注文更新IFを呼び出して得意先注文情報を修正する。
    const editData = () => {
        let dataUpdatesDetail = [];
        myGrid.props.data.map((item, index) => {
            if (isNotEmpty(item.jchusryo) && isNumber(item.jchusryo) && item.jchusryo > 0) {
                let dataDetail;
                dataDetail = {
                    shincd: item.shincd,
                    jchusryo: Number(item.jchusryo),
                    jchutnk: 0,
                    jchugaku: 0,
                    jchutnicd: item.jchutnicd,
                    kkokbn: item.kkokbn,
                    kkoniyo: item.kkoniyo,
                };
                dataUpdatesDetail.push(dataDetail);
            }
        })
        let bikoval = "";
        if (isNotEmpty(stateStore.state?.tsushinrancd) && stateStore.state?.tsushinrancd === stateStore.state?.tsushinrannaiyo) {
            bikoval = !$("option[value='" + stateStore.state?.tsushinrancd + "']").length ? null
                : $("option[value='" + stateStore.state?.tsushinrancd + "']")[0].innerText;
            //bikoval = $("option[value='" + stateStore.state?.tsushinrancd + "']")[0].innerText;
        }
        let params = {
            dnpyono: rootScope.openerParams.dnpyoNo,
            jchuymd: stateStore.state?.jchuymd.replaceAll('/', '-'),
            seizoymd: stateStore.state?.seizoymd.replaceAll('/', '-'),
            uketrihhocd: stateStore.state?.uketrihhocd,
            bikocd: bikoval,
            //bikomei: stateStore.state?.tsushinrannaiyo,
            bikomei: isEmpty(stateStore.state?.tsushinrannaiyo) ? null : stateStore.state?.tsushinrannaiyo,
            upddate: rootScope.openerParams.updDate,
            // jchugokeigaku: myGrid.props.data.reduce((result, item) => result + item.jchugaku, 0)
        };
        myGrid.props.data.map((item, index) => {
            errMsgService.delMsgKey(`kkoniyo${index}`);
        })
        // 有効な日付かチェック
        if (isDateFormatInvalid(stateStore.state?.seizoymd)) {
            dialogService.okDialog('EJYU0330', getMsg('EJYU0330'));
            return;
        }
        if (dataUpdatesDetail.length === 0) {
            dialogService.okDialog('EJYU0050', getMsg('EJYU0050'));
        } else {
            function commit(params) {
                // 2025/06/18 upd TuyenDT s 同じ受注番号でモバイル受注の受注データは2明細、さすがの受注データは3明細になります
                // 注文入力の状態を確認する
                dispatch(asyncService.async(jyuService.jyua108(params.dnpyono), (respose) => {
                    // 注文がEOS取込で送信されない場合は、修正できるようにする
                    if (respose.data) {
                        let checkFlag = false;
                        dataUpdatesDetail.map((checkData, index) => {
                            if (!checkData.kkoniyo && checkData.kkokbn === 1) {
                                checkFlag = true;
                                errMsgService.addMsgKey('EJYU0200', `kkoniyo${index}`, [index + 1, '加工内容']);
                            }
                        })
                        if (!checkFlag) {
                            params.tksakicmonmsaiAtDto = dataUpdatesDetail;
                            params.mode = getMode();
                            // 公開DBに得意先注文情報を保存する。
                            dispatch(asyncService.async(jyuService.jyua103(params), (respose) => {
                                let messageId = 'IJYU0210';
                                if (getMode() === '3') messageId = 'IJYU0220'
                                dialogService.okDialog(messageId, null, [rootScope.openerParams.dnpyoNo], okFunc, null, null, null);
                            }));
                        }
                    } else {
                        dialogService.okDialog('WJYU0190', null, [constMap.btnView.upd, constMap.btnView.upd], okFunc, null, null, null);
                    }
                }));
                // 2025/06/18 upd TuyenDT e 同じ受注番号でモバイル受注の受注データは2明細、さすがの受注データは3明細になります
            }
            // 受取方法 = '送り'の場合、納品希望日に休日を指定可能
            if (params.uketrihhocd == '10') {
                commit(params);
            } else {
                checkDayOffConfirm(dispatch, '納品希望日', 'seizoymd', stateStore.state?.seizoymd, commit, params);
            }
        }
    }

    // 得意先注文更新IFを呼び出して得意先注文情報を削除する。
    const deleteCustomerOrder = () => {
        // 2025/06/18 upd TuyenDT s 同じ受注番号でモバイル受注の受注データは2明細、さすがの受注データは3明細になります
        // 注文入力の状態を確認する
        dispatch(asyncService.async(jyuService.jyua108(rootScope.openerParams.dnpyoNo), (respose) => {
            // 注文がEOS取込で送信されない場合は、修正できるようにする
            if (respose.data) {
                let dataInsertsDetail = [];
                let params = {
                    dnpyono: rootScope.openerParams.dnpyoNo, jchuymd: '', seizoymd: '', uketrihhocd: '', bikocd: '', bikomei: '', updDate: rootScope.openerParams.updDate
                };

                params.tksakicmonmsaiAtDto = dataInsertsDetail;
                params.mode = '3';
                // 公開DBに得意先注文情報を保存する。
                dispatch(asyncService.async(jyuService.jyua103(params), (respose) => {
                    const messageId = 'IJYU0220';
                    dialogService.okDialog(messageId, null, [rootScope.openerParams.dnpyoNo], okFunc, null, null, null);
                }));
            } else {
                dialogService.okDialog('WJYU0190', null, [constMap.btnView.del, constMap.btnView.del], okFunc, null, null, null);
            }
        }));
        // 2025/06/18 upd TuyenDT e 同じ受注番号でモバイル受注の受注データは2明細、さすがの受注データは3明細になります
    }

    // 確認
    const okFunc = () => {
        if (getMode() === '1') {
            goto('Menu');
        } else {
            rootScope.openerParams.screenId = 'JYUF104';
            document.getElementById('btnBack').click();
        }
    }

    // 戻る
    const back = () => {
        dialogService.confirmDialog('WJYU0170', getMsg('WJYU0170'), null, okFunc, null, null, null);
    }
    // クリアデータ
    const okClearFunc = () => {
        // 初期処理
        init();
    }

    // クリアデータ確認ダイアログ
    const clearOnclick = () => {
        dialogService.confirmDialog('IJYU0180', getMsg('IJYU0180'), null, okClearFunc, null, null, null);
    }

    const getName = (code) => {
        const shin = stateStore.state.selectboxshincd.find(x => x.value === code);
        return shin ? shin.name : "";
    }

    return (
        <div>
            {/* 登録済かで切り替える */}
            <div>
                <div className="order-input">
                    <div>
                        <label>注文番号</label>
                        <label className="ml50">{slipNumber}</label>
                    </div>
                    <div className="mt5">
                        <label htmlFor="jchuymd">注文日</label>
                        <div className="jyuf104-input-display ml50">
                            <IsdTextboxYmd disabled className="w105" isCheckPastDay format="yyyy/MM/dd" name="jchuymd" value={stateStore.state?.jchuymd}
                                onChange={handleInputChange} ></IsdTextboxYmd>
                        </div>
                    </div>
                    <div className="mt5">
                        <label ref={initialRef.seizoymd} htmlFor="seizoymd">納品希望日</label>
                        <div className="jyuf104-input-display ml22">
                            <IsdTextboxYmd className="w105" isCheckPastDay required format="yyyy/MM/dd" name="seizoymd"
                                value={stateStore.state?.seizoymd} onChange={handleInputChange} onBlur={onBlurSeizoymd} disabled={stateStore.state?.disabled?.seizoymd}></IsdTextboxYmd>
                        </div>
                    </div>
                    <div className="mt5">
                        <label htmlFor="uketrihhocd">受取方法</label>
                        <div className="jyuf104-input-display ml35 w120">
                            <IsdSelectBox name="uketrihhocd" defaultkubunindex="-1" ref={initialRef.uketrihhocd} kbnvalue="UKETRIHHOCD" id="uketrihhocd"
                                value={stateStore.state?.uketrihhocd} onChange={selectChange} disabled={stateStore.state?.disabled?.uketrihhocd} />
                        </div>
                    </div>
                </div>
                <div id="gridWrapper" className="mt20">
                    <CustomGrid data={gridData} customItemSize={119} outsideHeight={355} minColumns={2} customClass={'Jyuf104'} />
                </div>
                <div className="mt5 message-wrap">
                    {/* <div className="mt5 align-right">
                        <label htmlFor="jchugokeigaku" >合計金額</label>
                        <div className="jyuf104-input-display ml10">
                            <IsdTextBox
                                ctrlproptype="num.comma"
                                isdmaxlength="12"
                                id="jchugokeigaku"
                                value={stateStore.state?.jchugokeigaku}
                                disabled
                                name="jchugokeigaku"
                            />
                        </div>
                    </div> */}
                    <div className="mt5">
                        <label htmlFor="tsushinrancd">通信欄 :</label>
                        <div className="jyuf104-input-display ml10">
                            <IsdSelectBox name="tsushinrancd" defaultkubunindex="-1" isInsertEmpty ref={initialRef.tsushinrancd} valueField="name" labelField="value" kbnvalue={selectdata} id="tsushinrancd"
                                value={stateStore.state?.tsushinrancd}
                                onChange={handleSelectChange}
                                disabled={stateStore.state?.disabled?.tsushinrancd} />
                        </div>
                        <div className="jyuf104-input-display bikomei ml10">
                            <IsdTextBox
                                ref={initialRef.tsushinrancd}
                                ctrlproptype="japan"
                                isdmaxlength="40"
                                id="tsushinrannaiyo" value={stateStore.state?.tsushinrannaiyo}
                                disabled={stateStore.state?.disabled?.tsushinrannaiyo}
                                name="tsushinrannaiyo"
                            />
                        </div>
                    </div>
                </div>
                <div className="button-content mt15">
                    <div hidden>
                        <Link to="/Jyuf105">
                            <button id='btnBack' className="btn ng-binding btn-custom"></button>
                        </Link>
                    </div>
                </div>
            </div>
        </div >
    );
})
export default Jyuf104;